"use strict";

Shopify.theme.jsMarqueeAnimation = {
  init: function init($wrapper) {
    this.marqueeAnimation($wrapper);
  },

  marqueeAnimation: function marqueeAnimation($wrapper) {
    var $marqueeWrapper = $wrapper.find('.js-marquee-wrapper');
    // Make an array from the elements within `.marquee__wrapper`
    const marqueeContent = Array.from($marqueeWrapper.children());

    marqueeContent.forEach((item) => {
      var duplicatedMarqueeItem = item.cloneNode(true);
      duplicatedMarqueeItem.setAttribute('aria-hidden', 'true');
      $marqueeWrapper.append(duplicatedMarqueeItem);
    });
  },
  unload: function unload($wrapper) {
    $wrapper.find('.js-marquee-wrapper').off();
  }
};
